import { render, staticRenderFns } from "./PersonalAwayApplicationTable.vue?vue&type=template&id=68fef5ba&scoped=true&"
import script from "./PersonalAwayApplicationTable.vue?vue&type=script&lang=js&"
export * from "./PersonalAwayApplicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fef5ba",
  null
  
)

export default component.exports